import { createStandardAction } from 'typesafe-actions'
import { Municipality } from 'types/Municipality'

/**
 * Action for updating the map with new data
 */
export const mapValuesUpdate = createStandardAction('VALUES/UPDATE')<
  Municipality[]
>()
/**
 * Action for setting the active municipality on the map
 */
export const mapActiveMunicipality = createStandardAction(
  'MAP/ACTIVE_MUNICIPALITY'
)<string>()
